<template>
  <div class="drivers-changes">
    <div class="driver-list">
      <div @click="goBack" class="backDiv" style="margin-left: 5px; margin-right: auto;">
        <i class="pi pi-arrow-left"></i>
        <span> Drivers</span>
      </div>
      <div class="driver-item" v-for="driver in paginatedDrivers" :key="driver.driverLicense">
        <p>{{ driver.driver_name }}</p>
        <div class="driver-info">
          <p>State: {{ driver.state }}</p>
          <p>License: {{ driver.driver_license }}</p>
          <p>Date of Birth: {{ driver.birth_date }}</p>
          <p>Years of Experience: {{ driver.year_experience }}</p>
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination">
      <button :disabled="currentPage === 1" @click="previousPage">Previous</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button :disabled="currentPage === totalPages" @click="nextPage">Next</button>
    </div>

    <div class="actions">
      <div class="change-text">
        <p class="change-request">Request Changes:</p>
        <p class="note">
          Please note that this does not initiate any changes to your current active policy.
        </p>
      </div>

      <textarea v-model="driverChanges" placeholder="Please list the changes you wish to make" class="changes-input"/>
      <button @click="goToEquipmentReview" class="btn btn-confirm done-button" :disabled="isButtonDisabled">Done! Go to Equipment Review<i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverChanges',
  data() {
    return {
      drivers: [],
      currentPage: 1,
      itemsPerPage: 6,
      driverChanges: ''
    };
  },
  computed: {
    paginatedDrivers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.drivers.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.drivers.length / this.itemsPerPage);
    },
    isButtonDisabled() {
      return !this.driverChanges || this.driverChanges.trim().length === 0;
    }
  },
  mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
      // Access the drivers array within the nested structure
      this.drivers = data.drivers || [];
    } else {
      console.error('No data found in localStorage');
    }

    const driverChangesCheck = localStorage.getItem('driver_changes');
    if (driverChangesCheck){
      console.log("driver changes exist in local");
      this.driverChanges = driverChangesCheck;
    } else {
      console.log("nothing exists");
    }
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToEquipmentReview() {
      if (this.driverChanges.trim()) {
        localStorage.setItem('driver_changes', this.driverChanges);
        this.$router.push({
        path: '/equipmentinfo'
      });
      } else {
        this.showError = true;
      }
    },
    goBack() {
      // Store the current scroll position
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Set a flag in sessionStorage before navigation
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);

      // Navigate back
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
i {
  margin-left: 10px;
}

.drivers-changes {
  text-align: center;
  padding: 10px;
}

.driver-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.driver-item {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 0px 20px;
  width: 95%;
  margin: 10px 0;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.driver-info {
  margin: 20px 0px;
}

.driver-info p {
  margin: 5px 0px;
}

.change-request {
  font-weight: bold;
}

.change-text {
  width: 94%;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
}

.changes-input {
  width: 100%;
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 5px;
  margin-bottom: 20px;
  box-sizing: border-box;
  height: 6em; /* Default height for larger screens */
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.pagination button {
  margin: 0 10px;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  background-color: #004d40;
  color: white;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .changes-input {
    height: 70px; /* Adjust this value for mobile screens */
  }
}

@media (max-width: 480px) {
  .changes-input {
    height: 150px; /* Adjust this value for smaller mobile screens */
  }
}

.note {
  color: #888;
  margin-bottom: 10px;
}

@media (min-width: 1000px) {
  .drivers-changes {
    width: 550px !important;
  }
}
</style>
